import React, { useState } from "react";
import "./Footer.css";

const Footer = () => {
  const [showContact, setShowContact] = useState(false)
  return <div className="footer">© 2025 Stridhaga.
    <div style={{marginBottom:'15px', cursor:'pointer'}} onClick={() => { setShowContact(!showContact) }}>{showContact ? 'Whatsapp : 8805126125' : 'Contact Us'}</div>
  </div>;
};

export default Footer;
